import { ContentFormat } from '@/domain/models/content/content-format'
import { Subtype } from '@/domain/models/content/subtype'
import { createLocalTimezoneDateFromString } from '@/main/helpers'
import {
  EngagementWorkflow,
  EnrollmentEngagementData,
  EnrollmentEngagementResponse
} from './enrollment-engagement-service-types'

export const formatEnrollmentEngagement = (
  apiData: EnrollmentEngagementResponse
): EnrollmentEngagementData => {
  const workflow =
    Object.values(EngagementWorkflow).find(v => v.toUpperCase() === apiData.workflow) ?? null

  if (!workflow) {
    throw new Error(`Unsupported engagement workflow: "${apiData.workflow}"`)
  }

  if (!apiData.step) {
    throw new Error(`Unsupported engagement step: "${apiData.step}"`)
  }

  return {
    name: apiData.name,
    institutionName: apiData.institutionName,
    subtype: apiData.subTypeId ? Subtype.getById(Number(apiData.subTypeId)) : null,
    format: apiData.format ? ContentFormat.getByName(apiData.format) ?? null : null,
    step: apiData.step,
    workflow,
    cancellationDate: createLocalTimezoneDateFromString(apiData.cancellationDate),
    orderId: apiData.orderId,
    coursePrice: apiData.coursePrice,
    courseCategoryId: apiData.courseCategoryId,
    coursePlan: apiData.coursePlan
  }
}
